import { render, staticRenderFns } from "./ProductSupplierFieldFilter.vue?vue&type=template&id=64547702"
import script from "./ProductSupplierFieldFilter.vue?vue&type=script&lang=ts"
export * from "./ProductSupplierFieldFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64547702')) {
      api.createRecord('64547702', component.options)
    } else {
      api.reload('64547702', component.options)
    }
    module.hot.accept("./ProductSupplierFieldFilter.vue?vue&type=template&id=64547702", function () {
      api.rerender('64547702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductSupplierFieldFilter.vue"
export default component.exports